import { render, staticRenderFns } from "./Guidelines.vue?vue&type=template&id=7f0d4d58&scoped=true&"
import script from "./Guidelines.vue?vue&type=script&lang=js&"
export * from "./Guidelines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0d4d58",
  null
  
)

export default component.exports